import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { capacityQueryKeys } from 'src/lib/query-keys/capacity';
import { TeamRolesApi } from '@/lib/api/team-roles';
import type { TeamRole } from '@/lib/api/types/teamRoles';

export const getTeamRolesQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.teamRoles.all(),
    queryFn: async () => {
      return await TeamRolesApi.getTeamRoles();
    },
  };
};

export const useTeamRolesQuery = (options: Partial<UseQueryOptions<TeamRole[]>> = {}) => {
  return useQuery({ ...getTeamRolesQueryOptions(), ...options });
};
